<template>
    <div class="l-searchresults">
        <div class="l-listings-grid">
            <div class="container flow-m">
                <div class="m-filters-grid flow">
                    <h2>Discover more of what matters to you</h2>
                    <search-filters></search-filters>
                </div>
                <div v-if="isLoading" class="loading-spinner">
                    <div class="spinner"></div>
                </div>
                <div v-else>
                    <div v-if="resultCount === 0">
                        <span class="e-noresults">
                            <p class="text-scale-small">
                                <strong>Sorry, there are no results that match your selection, please refine your search.</strong>
                            </p>
                        </span>
                    </div>
                    <div v-else class="flow-m">
                        <div>
                            <h2 class="text-scale-base text-colour-lightest leading-base">Showing {{resultsLoaded}} of {{resultCount}} results</h2>
                            <div id="js-results-count" class="js-results-count" aria-live="assertive">
                                <span class="visually-hidden">
                                    {{resultCount}} results
                                    sorted by Updated (newest)
                                </span>
                            </div>
                        </div>
                        <div class="grid-layout">
                            <search-list-item v-for="searchResult in searchResults" :key="searchResult.Id" :result-item="searchResult"></search-list-item>
                        </div>
                        <div>
                            <span>Showing {{resultsLoaded}} of {{resultCount}} results</span>
                            <search-pager v-if="moreResultsAvailable"></search-pager>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import BlogListItem from '@/components/KnowledgeLibrary/blog-list-item'
    //import EventsListItem from '@/components/KnowledgeLibrary/events-list-item'
    //import NewsListItem from '@/components/KnowledgeLibrary/news-list-item'
    // import PropertyListItem from '@/components/PropertySearch/property-list-item'
    import SearchFilters from '@/components/SiteSearch/search-filters'
    import SearchListItem from '@/components/KnowledgeLibrary/search-list-item'
    import SearchPager from '@/components/SiteSearch/search-pager'
    // import StaffListItem from '@/components/StaffSearch/staff-list-item'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { searchMixin } from '@/mixins/searchMixin.js'

    export default {
        components: {
            //BlogListItem,
            //EventsListItem,
            //NewsListItem,
            // PropertyListItem,
            SearchFilters,
            SearchListItem,
            SearchPager,
            // StaffListItem
        },

        computed: {
            isLoading() {
                return this.$store.getters.isLoading
            },

            filters: {
                get() {
                    return this.$store.state.search.filters
                },
                set() { }
            },

            moreResultsAvailable: function () {
                return this.$store.getters.moreResultsAvailable
            },

            resultsLoaded: function () {
                return this.$store.state.search.resultsLoaded
            },

            searchResults: function () {
                return this.$store.state.search.results
            },

            resultCount: function () {
                return this.$store.state.search.resultCount
            }
        },

        created: function () {
            this.$eventHub.$on('search-filtersChanged', this.OnFiltersChanged)
            this.$eventHub.$on('search-pageChanged', this.OnPageChanged)

            this.$store.dispatch('updateSearchFilter', { key: 'page', value: 1 })
            this.$store.dispatch('updateSearchFilter', { key: 'showAllResults', value: false })

            this.search(true)
        },

        data() {
            return {
                searchApiUrl: '/umbraco/api/SearchApi/Search'
            }
        },

        methods: {
            OnFiltersChanged: function () {
                this.search(true)
            },

            OnPageChanged: function () {
                this.search()
            }
        },

        mixins: [globalMixin, searchMixin],

        props: {
            locationLink: {
                default: null,
                type: String
            },

            showSearchResultsHeading: {
                default: false,
                type: Boolean
            }
        }
    }
</script>
